export const queryFragmentBlocks = {
  blocks: {
    populate: {
      fields: [
        'i18n_string_en',
        'i18n_string_nl',

        'i18n_richtext_en',
        'i18n_richtext_nl',

        'view_option',
      ],

      // images
      images: {
        populate: true
      },

      // external links
      external_links: {
        fields: ['url'],
        populate: {
          labels: true,
          descriptions: true
        }
      },

      // sponsors
      sponsors: {
        url: true,
        populate: {
          image: true
        }
      },

      // // links
      // ...queryFragmentLinks,

      // permanent-works
      entries: {
        populate: {
          titles: true,
          authors: true,
          slugs: true
        }
      },

      // image-text
      texts: true,
      image: true,

      // strapi
      stripe_product: {
        fields: '*',
        populate: {
          stripe_shipping_options: {
            fields: '*',
            populate: {
              countries: true
            }
          }
        }
      },
    }
  }
}

export const queryFragmentFirstRichTextBlock = {
  on: {
    'blocks.text': {
      limit: 1,
      fields: ['i18n_richtext_en'],
      filters: {
        i18n_richtext_en: {
          $notNull: true
        }
      }
    }
  }
}
